import { render } from "./HtsTrade.vue?vue&type=template&id=03fa0602&scoped=true"
import script from "./HtsTrade.vue?vue&type=script&lang=js"
export * from "./HtsTrade.vue?vue&type=script&lang=js"

import "./HtsTrade.vue?vue&type=style&index=0&id=03fa0602&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fa0602"]])

export default __exports__